import { useState,useCallback,useEffect, Suspense, lazy} from "react";
import { Switch, Route,useHistory, useLocation } from "react-router-dom";
import caAPI from "./services/caAPI";
import DommusLogoLoading from "./components/DommusLogoLoading";
import Swal from "sweetalert2";
import utilsService from "./services/utils";

export default function Routes() {
  const [tokenValido, setTokenValido] = useState(false);
  const history = useHistory();
  const location = useLocation()
  const VoipModal = lazy(() => import('./components/VoipModal'));
  const VoipIniciar = lazy(() => import('./components/VoipIniciar'));

  const handleTokenInvalido = () => {
    caAPI.logout();
    Swal.fire({
      titleText: "Esse dispositivo foi desconectado; faça login novamente",
      icon: 'warning',
      showCloseButton: true
    }).then(()=>{
      utilsService.fecharAtividade();
    })
  };

  const valida = useCallback(async function() {
    if(location && location.search){
      const queryParams = new URLSearchParams(location.search);
      let tokenUrl = queryParams && JSON.parse(queryParams.get('token'));
      let usuarioUrl = queryParams && queryParams.get('idUsuario');
      if (
        tokenUrl && usuarioUrl
      ) {
        caAPI
          .validaToken(tokenUrl)
          .then(async (res) => {
            const valido = res?.data?.valido || false;
            if(valido){
              caAPI.refreshApi(tokenUrl);
              caAPI.setLocalState('token', tokenUrl);
              await caAPI.setLocalState('idUsuario', usuarioUrl);
              setTokenValido(valido);
            }else{
              setTokenValido(false);
              throw "Acesso não autorizado";
            }
          })
          .catch((err) => {
            console.log(err);
            handleTokenInvalido();
          });
      }else{
        handleTokenInvalido();
      }
    }
  }, [location]);

  useEffect(() => {
    valida();
  }, [history.location.pathname, valida]);

  return (
    <Suspense fallback={<DommusLogoLoading />}>
      <Switch>
        {tokenValido && (
          <>
             <Route path="/receber" component={() => <VoipModal />}/>
             <Route path="/iniciar" component={() => <VoipIniciar />}/>
          </>
        )}
      </Switch>
    </Suspense>
  );
}
